import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ProgramService } from '@app/core/services/program/program.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { NavController, ModalController } from '@ionic/angular';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { WarningService } from '@app/core/services/warning/warning.service';
import { Store, select } from '@ngrx/store';
import { userSelectors, authSelectors } from '@app/core/ngrx/selectors';
import { State } from '@app/core/ngrx/reducers';
import { isNil } from '@app/shared/utils';
import { QueryService } from '@app/core/graphql/query/query.service';
import { CookieService } from 'ngx-cookie-service';
import { UserActions } from '@app/core/ngrx/actions';
import { Router } from '@angular/router';
import { SendEventActionsService } from '@core/services/events/sendEventActions.service';

import { ItineraryActions } from '@core/ngrx/actions';
import { itinerarySelectors } from '@core/ngrx/selectors';
// import { datadogRum } from '@datadog/browser-rum';
import { forkJoin, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { ItineraryCustomerInfoComponent } from '@app/shared/components/itinerary-customer-info/itinerary-customer-info.component';
import { ProgramSelectionComponent } from '@app/shared/components/program-selection/program-selection.component';
import { faExclamationCircle, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { UserService } from '@app/core/services/user/user.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PipesComponentsModule } from '@app/shared/pipes/pipes.modules';

@Component({
    selector: 'app-program-apply',
    templateUrl: './program-apply.component.html',
    styleUrls: ['./program-apply.component.scss'],
    animations: [
        trigger('slideInOut', [
            state(
                'in',
                style({
                    height: '33.5em',
                    opacity: '1',
                    visibility: 'visible',
                })
            ),
            state(
                'out',
                style({
                    height: '8.3em',
                    opacity: '1',
                    visibility: 'visible',
                })
            ),
            transition('out => in', [
                group([
                    animate(
                        '.2ms ease-in-out',
                        style({
                            visibility: 'visible',
                        })
                    ),
                    animate(
                        '400ms ease-in-out',
                        style({
                            height: '33.5em',
                        })
                    ),
                    animate(
                        '600ms ease-in-out',
                        style({
                            opacity: '1',
                        })
                    ),
                ]),
            ]),
        ]),
    ],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule, PipesComponentsModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramApplyComponent implements OnInit {
    @Output() applyInit = new EventEmitter<boolean>();
    // from status page
    @Input() status: any;
    // from details page
    @Input() program: any;
    // from details page
    @Input() profile: any;
    // form details page
    @Input() hasCustomAvailability?: any;
    // captcha token
    @Input() captchaToken?: string;
    // output program form
    @Output() onFormGroupChange = new EventEmitter<any>();
    @Output() formObject = new EventEmitter<any>();
    // input form
    @Input() application_form: FormGroup;
    // type
    @Input() typeFromParent: string;
    // time
    @Input() timeFromParent: any;

    icons: any = {
        faQuestionCircle: faQuestionCircle,
        faExclamationCircle: faExclamationCircle,
    };

    currentUrl;

    constructor(
        private store: Store<State>,
        private modalService: ModalService,
        private warning: WarningService,
        public toolService: ToolService,
        private queryService: QueryService,
        private navCtrl: NavController,
        private programService: ProgramService,
        private cookieService: CookieService,
        private applicationService: ApplicationService,
        private router: Router,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private sendEventActionsService: SendEventActionsService,
        private modalCtrl: ModalController,
        private userService: UserService
    ) {
        this.isManager$.subscribe((manager) => {
            this.manager = manager;
        });
    }

    booking: any = {
        start: true,
        apply: false,
        submitting: false,
        favorite: false,
    };

    customPrice: string = '';
    showProgramPrice: boolean;
    showCustomPrice: boolean = false;
    managementHidePrice = false;
    enableItineraries: boolean = false;

    noAvail = false;
    now: any;
    seatsRemaining: any;
    types: any[] = [];
    application: any;
    rows: any[] = [];
    programType: string;
    programTime: any;

    isManager$ = this.store.pipe(select(userSelectors.isManager));
    hidePrices$ = this.store.select(userSelectors.hideProgramPrices);
    isAuthenticated$ = this.store.pipe(select(authSelectors.isAuthenticated));
    manager: boolean;

    requestedHours: number;
    showHourlyTotal: boolean = false;
    hourlyPrice: number = 0;
    totalProgramPrice: number;

    // if user does not have a compatible field of study
    typeNotFoundForUser: boolean = false;

    stopwatchStart;

    customAlertOptions: any = {
        cssClass: 'time-selection',
    };

    itinerarySelections: any[] = [];

    ngOnInit(): void {
        this.store.select(itinerarySelectors.getItineraryList).subscribe((itineraryList: any) => {
            this.itinerarySelections = itineraryList.map((itineraryItem: any) => {
                return { ...itineraryItem };
            });

            if (this.itinerarySelections.length > 0) {
                this.enableItineraries = true;
            }
        });

        this.currentUrl = this.router.routerState;
        if (this.program !== undefined || null) {
            if (this.profile) {
                if (!isNil(this.profile.rules)) {
                    this.managementHidePrice = this.profile.rules.permissions.includes('program:hideprices');
                }
            }
            if (isNil(this.status)) {
                this.showProgramPrice = true;
            } else {
                this.showProgramPrice = false;
            }

            if (this.managementHidePrice) {
                this.showProgramPrice = false;
            }
            // if user has limited access to program details
            // provide no row options for dropdown
            if (this.cookieService.check('_temp_')) {
                this.tempOptions();
            } else {
                // get program availability
                this.isAuthenticated$
                    .pipe(
                        flatMap((isAuthenticated: any) => {
                            if (isAuthenticated) {
                                return forkJoin({
                                    availability: this.programService.availableDates(this.program.id, this.profile.fieldofstudy),
                                    types: this.userService.getUserTypesForProgram(),
                                });
                            } else {
                                return of(false);
                            }
                        })
                    )
                    .subscribe(({ availability, types }: any) => {
                        if (availability) {
                            this.rows = availability;
                        }
                        //
                        if (types && types.success) {
                            const programTypes = this.program.type ? this.program.type.split(',') : [];
                            this.types = types.types.filter((value) => programTypes.includes(value));
                            if (this.types.length === 1) {
                                this.application_form.patchValue({
                                    type: this.types[0],
                                });
                            }
                            // if no types founds
                            if (this.types.length === 0) {
                                this.typeNotFoundForUser = true;
                            }
                        } else {
                            this.types = this.program.type ? this.program.type.split(',') : [];
                        }

                        //
                        if (this.rows.length === 0) {
                            this.sendEventActionsService.sendEventActions({
                                eventAction: 'No Availability Loaded',
                                eventCategory: 'Program',
                                eventValue: this.program.id,
                                ddAction: 'No Availability Loaded',
                                ddContext: {
                                    tracer: 'No Availability Loaded',
                                    userEmail: this.profile.email,
                                    userId: this.profile.id,
                                },
                            });

                            this.noAvail = true;
                        } else {
                            this.sendEventActionsService.sendEventActions({
                                eventAction: 'Availability Loaded',
                                eventCategory: 'Program',
                                eventValue: this.program.id,
                                ddAction: 'Availability Loaded',
                                ddContext: {
                                    tracer: 'Availability Loaded',
                                    userEmail: this.profile.email,
                                    userId: this.profile.id,
                                },
                            });
                        }
                        if (availability.rows) {
                            this.rows = availability.rows.map((date: any) => {
                                if (this.profile && this.profile.fieldofstudy === 'Nurse Practitioner') {
                                    if (date.available === 1) {
                                        return {
                                            display:
                                                date.startdate.replace('-', ' ') +
                                                ' to ' +
                                                date.enddate.replace('-', ' ') +
                                                ' — 1 Seat available. — $' +
                                                date.hourlyprice +
                                                ' USD/hr',
                                            value: date.selection,
                                            price: date.price,
                                            startdate: date.startdate,
                                            enddate: date.enddate,
                                        };
                                    } else {
                                        return {
                                            display:
                                                date.startdate.replace('-', ' ') +
                                                ' to ' +
                                                date.enddate.replace('-', ' ') +
                                                ' — ' +
                                                date.available +
                                                ' Seats available — $' +
                                                date.hourlyprice +
                                                ' USD/hr',
                                            value: date.selection,
                                            price: date.price,
                                            startdate: date.startdate,
                                            enddate: date.enddate,
                                        };
                                    }
                                } else {
                                    if (date.available === 1) {
                                        return {
                                            display:
                                                date.startdate.replace('-', ' ') +
                                                ' to ' +
                                                date.enddate.replace('-', ' ') +
                                                ' — 1 Seat available. — $' +
                                                date.price +
                                                '.00 USD',
                                            value: date.selection,
                                            price: date.price,
                                            startdate: date.startdate,
                                            enddate: date.enddate,
                                        };
                                    } else {
                                        return {
                                            display:
                                                date.startdate.replace('-', ' ') +
                                                ' to ' +
                                                date.enddate.replace('-', ' ') +
                                                ' — ' +
                                                date.available +
                                                ' Seats available — $' +
                                                date.price +
                                                '.00 USD',
                                            value: date.selection,
                                            price: date.price,
                                            startdate: date.startdate,
                                            enddate: date.enddate,
                                        };
                                    }
                                }
                            });
                            this.types = this.program.type ? this.program.type.split(',') : [];
                            if (this.rows.length === 0) {
                                this.noAvail = true;
                            }
                        }
                    });
            }
        }

        if (this.typeFromParent) {
            this.programType = this.typeFromParent;
        }
        if (this.timeFromParent) {
            this.programTime = this.timeFromParent;
        }
    }

    // provide user to no options for program application
    tempOptions() {
        this.rows = [];
    }

    apply = () => {
        this.booking.start = false;
        this.booking.apply = true;
        this.applyInit.emit(this.booking.apply);
    };

    respExec(response) {
        // setTimeout(() => {
        this.navCtrl.navigateForward([`/application/${response.id}`]);
        // }, 2500);
    }

    submit() {
        this.angulartics2GoogleTagManager.eventTrack('New Application Button Click', { category: 'Program Details', label: this.program.id });

        if (!this.application_form.valid) {
            // this.alertService.error(`Type and start date are both required.`);
            this.warning.create('Please select both start date and type');
        } else {
            // management visitor submission check
            if (this.manager === true) {
                this.managementSubmit();
                return;
            }
            if (!this.booking.submitting) {
                this.booking.submitting = true;
                const dates = this.application_form.value['start'].value;
                const splits = dates.split(' ');
                const splitDates = splits[0].split('-');
                //
                //
                this.application_form.patchValue({
                    programid: this.program.id,
                    startdate: dates,
                    month: splitDates[0],
                    startyear: splitDates[2],
                    userid: this.profile.id,
                    fullname: this.profile.name,
                    useremail: this.profile.email,
                    status: this.profile.status,
                    nursing_hours: this.requestedHours ? this.requestedHours : null,
                    // captcha_token: this.captchaToken.toString()
                });

                // console.log(
                //     '  this.application_form  this.application_form',
                //     this.application_form
                // );
                this.applicationService.newApplication(this.application_form.value).subscribe(
                    (response: any) => {
                        if (response.type === 'success') {
                            this.angulartics2GoogleTagManager.pageTrack('/createdapplication');

                            this.sendEventActionsService.sendEventActions({
                                eventAction: 'New Application',
                                eventCategory: 'Application',
                                eventLabel: response.programid,
                                pageview: window.location.pathname,
                                ddAction: 'newApplication',
                                ddContext: {
                                    tracer: 'New Application',
                                    userEmail: this.profile.email,
                                    userId: this.profile.id,
                                },
                            });

                            this.booking.submitting = false;

                            const modalOpenCookie = this.cookieService.get('successModalOpen');

                            const showMultiStepModal = false;

                            if (showMultiStepModal === false || (modalOpenCookie && modalOpenCookie.length)) {
                                this.modalService
                                    .successfulAction({
                                        message: `Congratulations, your application was created! This window will now close.`,
                                    })
                                    .then((res) => {
                                        this.respExec(response);
                                    });
                                // this.respExec(response);
                            } else {
                                this.cookieService.set('successModalOpen', 'true');
                                this.modalService
                                    .applicationApplySuccess()
                                    .then((res: any) => {
                                        this.respExec(response);
                                    })
                                    .catch((error: Error) => {
                                        this.angulartics2GoogleTagManager.eventTrack('New Application Modal Error', {
                                            category: 'Application',
                                            label: response.programid,
                                        });
                                        setTimeout(() => {
                                            this.navCtrl.navigateForward([`/application/${response.id}`]);
                                        }, 300);
                                    });
                            }
                        } else {
                            this.booking.submitting = false;
                            if (response.profilevalid === false) {
                                this.warning.completeProfileWarning(response.message).then((confirm) => {
                                    if (confirm) {
                                        this.goToProfileBlock();
                                    }
                                });
                            } else {
                                this.angulartics2GoogleTagManager.eventTrack('New Application Warning', {
                                    category: 'Program Details',
                                    label: this.program.id + ' ' + response.message,
                                });

                                this.sendEventActionsService.sendEventActions({
                                    eventAction: 'New Application Validation Error',
                                    eventCategory: 'Application Validation',
                                    eventValue: response.message,
                                    ddAction: response.message,
                                    ddContext: {
                                        tracer: 'New Application Validation Error',
                                        userEmail: this.profile.email,
                                        userId: this.profile.id,
                                        value: response.message,
                                        programid: this.program.id,
                                    },
                                });

                                this.warning.create(response.message);

                                // this.alertService.basicAlert('Attention', 'New Application', `${response.message}`, ['Ok']);
                            }
                        }
                    },
                    (err: any) => {
                        this.angulartics2GoogleTagManager.eventTrack('New Application Error', {
                            category: 'Program Details',
                            label: this.program.id,
                        });

                        this.booking.submitting = false;
                    }
                );
            }
        }
    }

    updatePrice(ev: any) {
        if (ev && ev.detail && ev.detail.value) {
            const valueArr = ev.detail.value.split(' ');
            let floatPrice = valueArr[valueArr.length - 2].replace(/\$/g, '');
            const price = floatPrice.replace(/(\.|,)00$/g, '');
            if (!isNaN(price) && this.program.priceDropPrice < 1) {
                this.customPrice =
                    this.profile.fieldofstudy === 'Nurse Practitioner' && this.program.hourlyprice > 0 ? `$${price} USD/hour` : '$' + price + '.00 USD';
                this.showCustomPrice = true;
                this.showProgramPrice = false;
            }
        }
    }

    updateHourlyPricing(event) {
        if (this.requestedHours > 0) {
            this.showHourlyTotal = true;
            this.totalProgramPrice = Math.trunc(this.requestedHours * this.program.hourlyprice);
        } else {
            this.showHourlyTotal = false;
        }
    }

    managementSubmit() {
        // saved visitors from management set from permalink route guard
        const mgmtIDs = JSON.parse(sessionStorage.getItem('visitors'));
        let appsProcessed = 0;
        if (isNil(mgmtIDs)) {
            this.warning.create('Please select visitors from the Visitor page in the hosting site and select a program experience from the Programs grid.');
            return;
        } else {
            mgmtIDs.visitors.visitors.forEach((person) => {
                this.queryService.userlookup(person.id).subscribe((user) => {
                    this.booking.submitting = true;
                    const dates = this.application_form.value['start'].value;
                    const splits = dates.split(' ');
                    const splitDates = splits[0].split('-');
                    this.application_form.patchValue({
                        programid: this.program.id,
                        startdate: dates,
                        month: splitDates[0],
                        startyear: splitDates[2],
                        userid: user.data.findUser.id,
                        fullname: user.data.findUser.name,
                        useremail: user.data.findUser.email,
                        status: user.data.findUser.status,
                        // captcha_token: this.captchaToken.toString()
                    });

                    this.applicationService.newApplication(this.application_form.value).subscribe((response: any) => {
                        if (response.type === 'success') {
                            appsProcessed++;
                            if (appsProcessed === mgmtIDs.visitors.visitors.length) {
                                this.angulartics2GoogleTagManager.pageTrack('/createdapplication');
                                this.angulartics2GoogleTagManager.eventTrack('New Application', {
                                    category: 'Application',
                                    label: response.programid,
                                });

                                this.modalService
                                    .successfulAction({
                                        message: `Congratulations your application was created! This window now close.`,
                                    })
                                    .then((res: any) => {
                                        setTimeout(() => {
                                            window.close();
                                        }, 300);
                                    })
                                    .catch((error: Error) => {
                                        this.angulartics2GoogleTagManager.pageTrack('/createdapplication');
                                        this.angulartics2GoogleTagManager.eventTrack('New Application Modal Error', {
                                            category: 'Application',
                                            label: response.programid,
                                        });
                                        setTimeout(() => {
                                            window.close();
                                        }, 300);
                                    });
                            }
                            return;
                        } else {
                            this.booking.submitting = false;
                            // eslint-disable-next-line max-len
                            this.warning.create(
                                `${response.message}<br><p>Application failed for: </p><p>Applicant name: ${user.data.findUser.name}</p><p>Applicant ID: ${user.data.findUser.id}</p>`
                            );
                            return;
                        }
                    });
                });
            });
        }
    }

    showWarning = () => {
        this.warning.create('This program is currently unavailable to new applicants. Please email advisors@amopportunities.org.');
    };

    goToProfileBlock() {
        this.store.dispatch(
            UserActions.programRedirect({
                programRedirect: this.currentUrl.snapshot.url,
            })
        );
        this.navCtrl.navigateRoot(['/my-profile-block']);
    }

    goToItinerary() {
        // this.store.dispatch(UserActions.programRedirect({ programRedirect: this.currentUrl.snapshot.url }));
        this.navCtrl.navigateRoot(['/itinerary-create']);
    }

    addToItinerary() {
        if (!this.application_form.valid) {
            // this.alertService.error(`Type and start date are both required.`);
            this.warning.create('Please select both start date and type');
        } else {
            // management visitor submission check
            if (this.manager === true) {
                this.managementSubmit();
                return;
            }
            this.booking.submitting = true;
            const dates = this.application_form.value['start'].value;
            const splits = dates.split(' ');
            const splitDates = splits[0].split('-');
            const type = this.application_form.value['type'];
            //
            const array = new Uint16Array(4);
            const windowUUID = window.crypto.getRandomValues(array);

            var selection = {
                int_id: windowUUID[0].toString(),
                programid: this.program.id,
                programname: this.program.name,
                location: this.program.city + ', ' + this.program.state,
                startdate: this.application_form.value['start'].startdate,
                enddate: this.application_form.value['start'].enddate,
                price: this.application_form.value['start'].price,
                month: splitDates[0],
                startyear: splitDates[2],
                userid: this.profile.id,
                type: type,
                saved_selected_date: {
                    ...this.application_form.value['start'],
                },
            };

            // validate this selection with the API before adding it to the itineraryList store.
            this.applicationService
                .userValidateItinerarySelection({
                    existingitinerarylist: this.itinerarySelections,
                    currentselection: selection,
                })
                .subscribe(
                    (response: any) => {
                        if (response.success === true) {
                            var unsortedSelectionArray = this.itinerarySelections.concat(selection);

                            this.sendEventActionsService.sendEventActions({
                                pageview: '/add-to-itinerary',
                                eventAction: 'addToItinerary',
                                eventCategory: 'Itinerary',
                                ddAction: 'addToItinerary',
                            });

                            // sort by start date descending order
                            this.itinerarySelections = unsortedSelectionArray.sort(
                                (a: any, b: any) => new Date(a.startdate).getTime() - new Date(b.startdate).getTime()
                            );

                            this.store.dispatch(
                                ItineraryActions.setItineraryList({
                                    itineraryList: this.itinerarySelections,
                                })
                            );
                            // save itinerary to local storage next
                            localStorage.removeItem(String(this.profile.id + '-itinerarySelections'));

                            localStorage.setItem(this.profile.id + '-itinerarySelections', JSON.stringify(this.itinerarySelections));

                            this.applicationService
                                .updateUserItinerarySelections({
                                    selections: this.itinerarySelections,
                                })
                                .subscribe();

                            // this.warning.create(this.program.name + ' Has been added to your Itinerary');
                            this.application_form.reset();
                            this.booking.submitting = false;

                            // this.showItineraryPopover();
                            // this.warning.addedToItinerary(this.program.name + ' Has been added to your Itinerary').then(confirm => {
                            //   if (confirm) {
                            //     // this.goToProfileBlock();
                            //   } else {

                            this.modalService
                                .successfulAction({
                                    message: `Program added to Itinerary.`,
                                })
                                .then((res: any) => {
                                    setTimeout(() => {
                                        this.goToItinerary();
                                    }, 300);
                                })
                                .catch((error: Error) => {
                                    setTimeout(() => {
                                        this.goToItinerary();
                                    }, 300);
                                });

                            //   }
                            // })
                        } else {
                            this.warning.create(response.message);
                            this.booking.submitting = false;
                        }
                    },
                    (err: any) => {
                        this.warning.create(err.error.message);
                        this.booking.submitting = false;
                    }
                );
        }
    }

    submitItinerary() {
        this.applicationService
            .newItinerary({
                userid: this.profile.id,
                selections: this.itinerarySelections,
            })
            .subscribe(
                (response: any) => {
                    if (response.success === true) {
                        this.modalService
                            .successfulAction({
                                message: `Congratulations your application chain was created! .`,
                            })
                            .then((res: any) => {
                                this.angulartics2GoogleTagManager.pageTrack('/createdapplicationchain');
                                this.angulartics2GoogleTagManager.eventTrack('New Application Chain', { category: 'Application' });
                                setTimeout(() => {
                                    window.close();
                                }, 300);
                            })
                            .catch((error: Error) => {
                                console.log(error);
                            });
                    }
                },
                (err: any) => {
                    this.warning.create(err.error.message);
                }
            );
    }

    async showItineraryPopover() {
        this.programService.setScrollItinerarySubject.next(true);
    }

    openItineraryInfo(ev: MouseEvent) {
        this.modalService.itiHelp(ev).then((res: any) => {
            /* empty */
        });
    }

    async openItineraryModal(ev: MouseEvent) {
        const itiInfoModal = await this.modalCtrl.create({
            component: ItineraryCustomerInfoComponent,
            backdropDismiss: true,
            cssClass: 'itinerary-notify-popup',
            // cssClass: 'program-notify-popup'
        });

        itiInfoModal.onDidDismiss().then(() => {
            /* empty */
        });

        //
        //
        await itiInfoModal.present();
        return { success: false };
        //
    }
    // openCart(){
    //     let modal = this.modalCtrl.create(CartPage, { data: this.cart });
    //     modal.present();
    // }

    async openProgramModal(val) {
        if (val == 'type') {
            const proSeleModal = await this.modalCtrl.create({
                component: ProgramSelectionComponent,
                backdropDismiss: true,
                cssClass: 'program-notify-popup',
                componentProps: {
                    data: this.types,
                },
            });

            proSeleModal.onDidDismiss().then((data) => {
                if (data && data.data) {
                    this.programType = data.data.programType; // Here's your selected user!
                }

                this.formObject.next({
                    programtype: this.programType,
                    programtime: this.programTime,
                });
            });
            // then((data) => {

            //
            //
            await proSeleModal.present();
            return { success: false };
            //
        } else if (val == 'time') {
            const proSeleModal = await this.modalCtrl.create({
                component: ProgramSelectionComponent,
                backdropDismiss: true,
                cssClass: 'program-notify-popup-wide',
                componentProps: {
                    rowData: this.rows,
                    userEmail: this.profile.email,
                    fieldOfStudy: this.profile.fieldofstudy,
                },
            });

            proSeleModal.onDidDismiss().then((data) => {
                if (data && data.data) {
                    if (data && data.data && data.data.parentRowData && data.data.parentRowData.price) {
                        let price = data.data.parentRowData.price;

                        this.customPrice = new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 0,
                        })
                            .format(price)
                            .concat(' USD');

                        if (this.program.priceDropPrice) {
                            this.showCustomPrice = true;
                            this.showProgramPrice = false;
                        }
                    }
                    this.programTime = data.data.parentRowData; // Here's your selected user!
                    this.formObject.next({
                        programtype: this.programType,
                        programtime: this.programTime,
                    });
                }
            });
            // then((data) => {

            await proSeleModal.present();
            return { success: false };
        }
    }
}
